var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "mx-1", attrs: { flat: "" } },
    [
      _c(
        "v-container",
        { staticClass: "ma-2 pa-2" },
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "div",
                  { staticClass: "overline" },
                  [
                    _c(
                      "v-row",
                      { staticClass: "mx-auto d-flex align-center overline" },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v(" mdi-account-group ")
                        ]),
                        _c(
                          "p",
                          {
                            staticClass:
                              "font-weight-light caption pa-2 mx-0 my-0"
                          },
                          [
                            _vm._v(
                              " Personas involucradas al acceso al centro de datos "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._l(_vm.ticketDetail.accessPermission.accessContacts, function(
                i,
                k
              ) {
                return _c(
                  "v-col",
                  {
                    key: k,
                    staticClass: "mx-auto",
                    attrs: {
                      cols:
                        _vm.ticketDetail.accessPermission.accessContacts
                          .length < 4
                          ? 8
                          : 6
                    }
                  },
                  [
                    _c(
                      "v-card",
                      {
                        staticClass: "text-center pa-2 ma-1",
                        style:
                          "border-top: solid 5px " +
                          _vm.getColor(i.contactDetails[0].contactType.id),
                        attrs: { outlined: "" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "fill-height align-center" },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  color: _vm.getColor(
                                    i.contactDetails[0].contactType.id
                                  )
                                }
                              },
                              [_vm._v("mdi-account")]
                            ),
                            _c("div", { staticClass: "overline" }, [
                              _vm._v(
                                "Persona " + _vm._s(_vm.getContactTypes(i.id))
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-card-title",
                          { staticClass: "caption justify-center" },
                          [
                            _c("div", [
                              _vm._v(_vm._s(i.name) + " " + _vm._s(i.lastName))
                            ])
                          ]
                        ),
                        _c("v-card-subtitle", { staticClass: "fs-10" }, [
                          _vm._v(_vm._s(i.company))
                        ]),
                        _c(
                          "v-row",
                          {
                            staticClass:
                              "fs-10 pb-2 px-3 mt-n3 text-center justify-center",
                            attrs: { align: "center", "no-gutters": "" }
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "px-1" },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-card-account-details-outline")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" " + _vm._s(i.identification) + " ")
                            ]),
                            _c("span", { staticClass: "pa-2" }),
                            _c("div", { staticClass: "pr-1" }, [
                              _c(
                                "span",
                                { staticClass: "px-1" },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-phone-outline")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" " + _vm._s(i.phone) + " ")
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }